import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  forwardRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'kt-custom-switch',
  templateUrl: './custom-switch.component.html',
  styleUrls: ['./custom-switch.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomSwitchComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class CustomSwitchComponent implements OnInit, ControlValueAccessor {
  @Input() isActive: boolean;
  @Input() label: string;
  @Input() disabled: boolean;
  @Input() id: string;
  @Input() customColorOutline: string;
  @Input() customColorInside: string;
  @Input() isTrackAndTrace: boolean;
  @Input() labelPosition: 'left' | 'right' = 'left';
  @Output() change = new EventEmitter<boolean>();
  private _value: any = false;

  constructor() {}

  ngOnInit() {}

  onToggleSwitch() {
    if (!this.disabled) {
      this.change.emit(!this.isActive);
      this.onChange(this.isActive); // Notify Angular about the value change
    }
  }

  // Implement ControlValueAccessor methods
  writeValue(obj: any): void {
    if (obj !== this._value) {
      this._value = obj;
      this.onChange(obj);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};
}
